import axios from 'axios';
import API_URL from '../constants/environment';

export interface ResolvedSupplierForAlias {
    _id: string;
    title: string;
}

/**
 * Best-effort lookup via API. Returns null when the route is unavailable (e.g. not deployed yet).
 */
export async function resolveSupplierForVendorAliasSave(
    sessionId: string,
    args: { supplierId?: string | null; nexVendorId?: number }
): Promise<ResolvedSupplierForAlias | null> {
    const supplierId = (args.supplierId ?? '').trim();
    const vendorId = args.nexVendorId;

    const tryRequest = async (params: Record<string, string | number>): Promise<ResolvedSupplierForAlias | null> => {
        try {
            const { data } = await axios.get<{ supplier: ResolvedSupplierForAlias | null }>(
                `${API_URL}/supplier/by-nex-vendor-id`,
                {
                    headers: { Authorization: sessionId },
                    params,
                    validateStatus: (status) => status === 200 || status === 400,
                }
            );
            return data.supplier ?? null;
        } catch {
            return null;
        }
    };

    if (supplierId) {
        const byId = await tryRequest({ supplierId });
        if (byId) return byId;
    }

    if (vendorId == null || !Number.isFinite(vendorId)) return null;
    return tryRequest({ vendorId });
}
